export default "__VITE_ASSET__C2uSosGZ__"